import {
    TABLE_BODY_WIDTH,
    TABLE_EDIT_CONTROL_WIDTH,
    TABLE_EDIT_OUTER_PADDING,
} from "canvas/table/geometry";
import { EditColumn } from "diagram/model/edit/edit";
import * as React from "react";
import { Button } from "app/button/button";
import { IconComponent, Icons } from "utilities/icon";

interface Props {
    columns: EditColumn[];
    columnsExpanded: boolean;
    setColumnsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

const renderColumn = (column: EditColumn, index: number) => (
    <div
        key={column.id}
        className={[
            "h-6 px-1 flex flex-0 items-center",
            index === 1 ? "justify-end text-right" : "",
            "text-[var(--diagram-table-text)]",
        ].join(" ")}
        style={{ width: TABLE_BODY_WIDTH / 2 }}
        children={column.value.name}
    />
);

const getExpandIcon = (isExpand: Boolean): IconComponent =>
    isExpand ? Icons.doubleChevronLeft : Icons.doubleChevronRight;

export const TableColumns = (props: Props) => (
    <div
        className={[
            "bg-[var(--diagram-table-header-bg)]",
            "border-[var(--diagram-table-border)]",
            "animate-top-slide-in leading-5 flex items-center border-none border-[1px]",
            "text-[var(--diagram-table-muted)]",
        ].join(" ")}
    >
        <div
            className="block flex-0 h-6"
            style={{ width: TABLE_EDIT_OUTER_PADDING }}
        />

        {/* Padding, should be the same as the "delete" button on row */}
        <div
            className="block flex-0 h-6"
            style={{ width: TABLE_EDIT_CONTROL_WIDTH }}
        />

        {props.columns
            .slice(0, props.columnsExpanded ? undefined : 2)
            .map(renderColumn)}

        <div
            className="h-6 flex flex-0 items-center justify-center"
            style={{ width: TABLE_EDIT_CONTROL_WIDTH }}
        >
            PK
        </div>

        {/* Should be the same as the "drag" button on row */}
        <Button
            color="clear"
            onClick={() => props.setColumnsExpanded((b) => !b)}
            icon={getExpandIcon(props.columnsExpanded)}
            iconSize={12}
            paddingStyle="p-0"
            extraStyle="h-6 flex-0 items-center text-[var(--diagram-table-muted)]"
            style={{ width: TABLE_EDIT_CONTROL_WIDTH }}
        />
        <div
            className="block flex-0 h-6"
            style={{ width: TABLE_EDIT_OUTER_PADDING }}
        />
    </div>
);
